import { render, staticRenderFns } from "./collapsable-layout.component.vue?vue&type=template&id=8ad00704&scoped=true"
import script from "./collapsable-layout.component.vue?vue&type=script&lang=ts"
export * from "./collapsable-layout.component.vue?vue&type=script&lang=ts"
import style0 from "./collapsable-layout.component.vue?vue&type=style&index=0&id=8ad00704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad00704",
  null
  
)

export default component.exports